<template>
  <div
    class="jobfair-info"
    v-loading="!jobfairInfo.name"
    element-loading-background="rgba(0,127,255, 0.3)"
  >
    <div class="container info-top-box" v-if="jobfairInfo.name">
      <p class="bg-img left-img"></p>
      <p class="bg-img right-img"></p>
      <div class="info-top">
        <div class="jobfair-name" @click="companyHall">
          {{ jobfairInfo.name }}
          <span class="btn-status">{{ jobfairInfo.current_status }}</span>
        </div>
        <div class="jobfair-org">
          <span class="btn">主办方 {{ jobfairInfo.organizers }}</span>
        </div>
        <div class="jobfair-desc">
          <el-row :gutter="30" v-if="infoType == 'online'">
            <el-col :span="10" class="tl">
              <p>
                <span>学历层次: {{ jobfairInfo.educations }}</span>
              </p>
              <p>
                <span>招聘需求: {{ jobfairInfo.job_number }}人</span>
              </p>
            </el-col>
            <el-col :span="14" class="tl">
              <el-row :gutter="10">
                <el-col :span="10">
                  <span>地区: {{ jobfairInfo.city || "全国" }}</span>
                </el-col>
                <el-col :span="14" v-if="jobfairInfo.co_organizer">
                  <el-tooltip
                    effect="dark"
                    :content="jobfairInfo.co_organizer"
                    placement="top"
                  >
                    <span>协办: {{ jobfairInfo.co_organizer }}</span>
                  </el-tooltip>
                </el-col>
              </el-row>
              <p>
                <span
                  >时间: {{ jobfairInfo.start_time }}至{{
                    jobfairInfo.end_time
                  }}</span
                >
              </p>
            </el-col>
          </el-row>
          <el-row :gutter="30" v-else>
            <el-col :span="18" class="tl">
              <p>
                <span>举办时间: {{ jobfairInfo.meet_time }} - {{ jobfairInfo.meet_end_time }}</span>
              </p>
              <p>
                <span>举办地址: {{jobfairInfo.address}}</span>
              </p>
              <p>
                <span>主办方: {{ jobfairInfo.organisers }}</span>
              </p>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <div class="info-bottom">
      <div class="container">
        <el-row :gutter="10">
          <el-col :span="4" class="count-box">
            <span class="count-numbs" v-if="infoType == 'online'">
              {{ jobfairInfo.company_count&&jobfairInfo.company_count.approve_count ? jobfairInfo.company_count.approve_count : 0 }}
            </span>
            <span class="count-numbs" v-else>
              {{ jobfairInfo.count_info&&jobfairInfo.count_info.company_count ? jobfairInfo.count_info.company_count : 0 }}
            </span>
            <span class="count-name">企业数</span>
          </el-col>
          <el-col :span="4" class="count-box">
            <span class="count-numbs" v-if="infoType == 'online'">{{ jobfairInfo.post_count }}</span>
            <span class="count-numbs" v-else>{{ jobfairInfo.count_info&&jobfairInfo.count_info.job_count ? jobfairInfo.count_info.job_count : 0 }}</span>
            <span class="count-name">职位数</span>
          </el-col>
          <el-col :span="4" class="count-box">
            <span class="count-numbs" v-if="infoType == 'online'">{{ jobfairInfo.job_number }}</span>
            <span class="count-numbs" v-else>{{ jobfairInfo.count_info&&jobfairInfo.count_info.post_count ? jobfairInfo.count_info.post_count : 0 }}</span>
            <span class="count-name">岗位数</span>
          </el-col>
          <!-- <el-col :span="4" class="count-box">
            <span class="count-numbs">{{ jobfairInfo.seeker_numbs }}</span>
            <span class="count-name">报名数</span>
          </el-col> -->
          <el-col :span="12">
            <div class="barrage">
              <barrage
                :arr="barArr"
                :percent="100"
                :channel-count="2"
                class-name="normal-main"
              ></barrage>

              <p class="left-modal"></p>
              <p class="right-modal"></p>
              <p class="left-gradient-modal"></p>
              <p class="right-gradient-modal"></p>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { Tooltip, MessageBox } from "element-ui";
Vue.use(Tooltip);

import Barrage from "@/components/Barrage/Barrage";

export default {
  name: "jobfair-info",
  components: { Barrage },
  props: {
    video_jobfair_id: {
      type: String,
      default: "",
    },
    // 是否无需登录
    allowVisitor: {
      type: Boolean,
      default: false,
    },
    infoType: {
      type: String,
      default: 'online',
    },//信息类型 online 视频双选会
    school_id: {
      type: String,
      default: "",
    }
  },
  computed: {},
  data() {
    return {
      jobfairInfo: {},
      moveBar: {
        list: [],
        maxIndex: 0,
        onIndex: 0,
      },
      cacheBar: {
        list: [],
        current: 0,
        key: "kzp_cache_bar",
        distance: 600000,
        polingTime: 5 * 60 * 1000,
        timer: null,
      },
      barConfig: {
        timer: null,
        frstTimer: null,
        step: 2,
      },
      barArr: [],
    };
  },
  mounted() {
    this.getDetail();
  },
  methods: {
    getDetail: function () {
      var _self = this;
      const { video_jobfair_id, allowVisitor, school_id } = this;
      let url = '';
      let request = '';
      let params = {}
      if(this.infoType == 'online'){
        request = "kzp_video_jobfair"
        url = "video_jobfair_detail"
        params = {video_jobfair_id}
      }else{
        request = "kzp_offline_jobfair"
        url = "offline_jobfair_detail"
        params = {
          offline_jobfair_id: video_jobfair_id,
          school_id: school_id,
          com: 0
        }
      }
      this.$util
        .get(request, url, params)
        .then((res) => {
          const { msg, code, data } = res || {};
          if (code !== 1) {
            // 求职者为报名，提示
            MessageBox.alert(msg || "获取信息失败", "提示", {
              confirmButtonText: "确定",
              type: "warning",
              showClose: false,
              closeOnClickModal: false,
              // showCancelButton: false,
              callback: (action) => {
                // action: cancel、confirm
                // 回到双选会详情页
                _self.$util.pageto(this.infoType == 'online' ? "jobfair_detail" : "offline_detail", {
                  video_jobfair_id,
                });
              },
            });
            return;
          }

          let { register , detail} = data || {};
          var jobfairInfo = ''
          if(this.infoType == 'online'){
            if (!register) {
              // 求职者为报名，提示
              let confirmData = {
                confirmButtonText: "确定",
                type: "warning",
                showClose: false,
                closeOnClickModal: false,
              };

              if (allowVisitor === false) {
                confirmData.showCancelButton = false;
                confirmData.callback = () => {
                  _self.$util.pageto("jobfair_detail", {
                    video_jobfair_id,
                  });
                };
              } else {
                confirmData.callback = (action) => {
                  // action: cancel、confirm
                  // 回到双选会详情页
                  if (action == "confirm") {
                    _self.$util.pageto("jobfair_detail", {
                      video_jobfair_id,
                    });
                  }
                };
              }
              MessageBox.confirm("您还未报名，请先报名!", "提示", confirmData);
              if (allowVisitor === false) {
                return;
              }
            }
            // init弹幕
            _self.getBarList(true).then(() => {
              _self.initBarrageList();
            });
            if (detail) {
            jobfairInfo = detail;
            _self.$util.tansPics(jobfairInfo, "img");
            jobfairInfo.jobfair_desc = _self.$util.filterRichText(
              jobfairInfo.jobfair_desc
            );
            jobfairInfo.seeker_register_desc = _self.$util.filterRichText(
              jobfairInfo.seeker_register_desc
            );

            _self.jobfairInfo = jobfairInfo;

            if (register) {
              _self.register = data.register;
            }
          }
          }else{
            register = true
            detail = data.offline_jobfair
            if (detail) {
              jobfairInfo = data.offline_jobfair;
              _self.$util.tansPics(jobfairInfo, "scene_pics");
              jobfairInfo.jobfair_desc = _self.$util.filterRichText(
                jobfairInfo.content
              );
              jobfairInfo.seeker_register_desc = _self.$util.filterRichText(
                jobfairInfo.recruit_stu_notices
              );
              jobfairInfo.name = jobfairInfo.title
              
              jobfairInfo.count_info = data.count_info
              _self.jobfairInfo = jobfairInfo;
            }
            _self.register = true;
          }
          // 通知页面可以正常加载
          const is_signed = register ? true: false
          _self.$emit("init", detail, is_signed);

          
        });
    },

    // 进入企业大厅页面
    companyHall: function () {
      const { video_jobfair_id } = this;
      let url = this.infoType == 'online' ? 'jobfair_company' : 'offline_company';
      let params = this.infoType == 'online' ? { video_jobfair_id: video_jobfair_id } : {fair_id: video_jobfair_id, school_id: this.school_id};
      this.$util.pageto(url, params);
    },

    // 初始化模拟弹幕数据
    initBarrageList() {
      var _self = this;
      var barArr = [];
      _self.cacheBar.list.forEach((item) => {
        return barArr.push({
          direction: "default",
          content: (item.create_time || "") + " " + item.log_desc,
          isSelf: false,
          style: {},
        });
      });

      _self.$set(_self, "barArr", barArr);
    },
    // 获取弹幕 ajax_get_video_jobfair_log
    getBarList(initParams) {
      const { video_jobfair_id, cacheBar } = this;
      let _self = this;

      const { distance } = cacheBar;

      const key = cacheBar.key + "_" + video_jobfair_id;

      return new Promise((resolve) => {
        // 获取当前时间戳
        var timestamp = new Date().getTime();

        var sessionData;

        try {
          sessionData = JSON.parse(sessionStorage.getItem(key) || "{}");
        } catch (error) {
          //
        }

        if (
          sessionData &&
          sessionData.data &&
          sessionData.time + distance > timestamp
        ) {
          if (initParams) {
            _self.cacheBar.list = sessionData.data;
            resolve();
          }
          return;
        }

        this.$util
          .get("kzp_video_jobfair", "get_video_jobfair_log", {
            video_jobfair_id: video_jobfair_id,
          })
          .then((res) => {
            var data = res.data;
            if (res.code === 1 && data && data.length > 0) {
              _self.cacheBar.list = data;
              sessionStorage.setItem(
                key,
                JSON.stringify({ data: data, time: timestamp })
              );

              resolve();
            }
          });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.jobfair-info {
  padding: 0.1rem 0 0.4rem;
  .info-top-box {
    position: relative;

    .bg-img {
      position: absolute;
      bottom: 0;

      @include background-size(cover);
      background-position: center center;
      background-repeat: no-repeat;
    }

    .left-img {
      width: 2.2rem;
      height: 1.78rem;
      left: 0;
      background-image: url("https://o.bysjy.com.cn/kzp/video_jobfair/jobfair_info_left.png");
    }

    .right-img {
      width: 2.25rem;
      height: 1.73rem;
      right: 0;
      background-image: url("https://o.bysjy.com.cn/kzp/video_jobfair/jobfair_info_right.png");
    }
  }

  .info-top {
    position: relative;
    z-index: 10;
    max-width: 7.5rem;
    margin: 0 auto;
    padding: 0.46rem 0 0.5rem;
    text-align: center;

    .jobfair-name {
      line-height: 0.48rem;
      font-size: 0.34rem;
      font-weight: 800;
      color: #ffffff;
      vertical-align: middle;
      cursor: pointer;

      &:hover {
        color: #f3f3f3;
      }

      .btn-status {
        display: inline-block;
        vertical-align: middle;
        border: 2px solid #fccc6c;
        height: 0.36rem;
        line-height: 0.36rem;

        font-size: 0.18rem;
        font-weight: 500;
        color: #fccc6c;
        padding: 0 0.05rem;
        @include border-radius(0.18rem);
        white-space: nowrap;
        @include box-sizing(border-box);
      }
    }

    .jobfair-org {
      margin: 0.2rem 0 0.3rem;
      .btn {
        display: inline-block;
        font-size: 0.3rem;
        font-weight: 500;
        line-height: 0.36rem;
        color: #0052d9;
        padding: 0.08rem 0.2rem;

        @include linear-gradient(bottom, #fdd577, #f9aa42);

        @include border-radius(0.26rem);
      }
    }

    .jobfair-desc {
      color: #ffffff;
      span {
        font-size: 0.16rem;
        display: inline-block;
        max-width: 100%;
        @include over-ellipsis();
      }
    }
  }

  $bottomColor: rgb(0, 102, 255);

  .info-bottom {
    background-color: $bottomColor;
    // height: 1.02rem;
    padding: 0.26rem;

    @include box-sizing(border-box);
  }

  .count-box {
    position: relative;
    z-index: 10;
    .count-numbs,
    .count-name {
      display: inline-block;
      vertical-align: middle;
    }

    .count-numbs {
      font-size: 0.42rem;
      font-weight: 500;
      line-height: 0.51rem;
      color: #ffffff;
    }

    .count-name {
      font-size: 0.17rem;
      font-weight: 600;
      line-height: 0.3rem;
      color: #ffffff;

      border-bottom: 0.03rem solid #f9aa42;
    }
  }

  .barrage {
    position: relative;
    height: 51px;
    // overflow: hidden;
    .barrage-list {
      height: 0.25rem;
      position: relative;

      .barrage-item {
        position: absolute;
        top: 0;
        left: 110%;

        max-width: 45%;
        @include over-ellipsis();

        font-size: 0.12rem;
        font-weight: 400;
        line-height: 0.18rem;
        color: #fffdfb;
        border: 0.01rem solid #fff;
        padding: 0.01rem 0.05rem;
        @include border-radius(0.1rem);
        white-space: nowrap;
      }

      .barrage-move {
        left: -60%;
        transition: all 9s linear;
      }
    }

    .left-modal {
      position: absolute;
      z-index: 5;
      width: 50%;
      height: 100%;
      left: -60%;
      top: 0;
      background-color: $bottomColor;
    }

    .left-gradient-modal {
      position: absolute;
      z-index: 5;
      width: 10%;
      height: 100%;
      left: -10%;
      top: 0;
      @include linear-gradient(right, $bottomColor, rgba(0, 102, 255, 0.1));
    }

    .right-gradient-modal {
      position: absolute;
      z-index: 5;
      width: 10%;
      height: 100%;
      right: 0;
      top: 0;
      @include linear-gradient(left, $bottomColor, rgba(0, 102, 255, 0.1));
    }

    .right-modal {
      position: absolute;
      z-index: 5;
      width: 100%;
      height: 100%;
      right: -100%;
      top: 0;
      background-color: $bottomColor;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/JobfairInfo/JobfairInfo.vue